import { useTranslation } from "@redotech/redo-i18n";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { Flex } from "@redotech/redo-web/flex";
import {
  getReturnRateSourceOptionLabel,
  type ReturnRateSourceOption,
} from "../rate-source-selection-utils";
import { RateSourceSelectionCard } from "./rate-source-selection-card";

interface DropoffsCardProps {
  dropoffOptions: ReturnRateSourceOption[];
  onDropoffChange(option: ReturnRateSourceOption, selected: boolean): void;
  selectedDropoffOptionIds: Set<ReturnRateSourceOption["id"]>;
}

export function DropoffsCard({
  dropoffOptions,
  onDropoffChange,
  selectedDropoffOptionIds,
}: DropoffsCardProps) {
  const { t } = useTranslation();

  return (
    <RateSourceSelectionCard title={t("Dropoffs")}>
      <Flex dir="column" gap="sm">
        {dropoffOptions.map((option) => (
          <RedoCheckbox
            key={option.id}
            label={getReturnRateSourceOptionLabel(t, option)}
            setValue={(value) => {
              onDropoffChange(option, value === true);
            }}
            size="xs"
            value={selectedDropoffOptionIds.has(option.id)}
          />
        ))}
      </Flex>
    </RateSourceSelectionCard>
  );
}
